import React from 'react';
import { motion } from 'framer-motion';

interface BestieProfile {
  name: string;
  superpower: string;
  emoji: string;
  color: string;
}

const besties: BestieProfile[] = [
  {
    name: 'Elsa',
    superpower: 'Squeezing lemons into delicious drinks and marketing mastermind!',
    emoji: '🍋',
    color: 'bg-yellow-100'
  },
  {
    name: 'Spencer',
    superpower: 'Cupcake Decoration QUEEN',
    emoji: '🧁',
    color: 'bg-purple-100'
  },
  {
    name: 'Maria',
    superpower: 'Money Boss and Pink Lemonade EXPERT',
    emoji: '💰',
    color: 'bg-pink-100'
  },
  {
    name: 'Maddie',
    superpower: 'Lemonade hander-outer and banana bread boss',
    emoji: '🍌',
    color: 'bg-amber-100'
  }
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const item = {
  hidden: { opacity: 0, scale: 0.8 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.5 } }
};

const AboutPage: React.FC = () => {
  return (
    <div className="px-2 sm:px-0">
      <motion.h1 
        className="text-3xl md:text-4xl font-baloo text-yellow-500 mb-6 md:mb-8 text-center sm:text-left"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        About Us
      </motion.h1>
      
      <motion.div 
        className="card mb-6 md:mb-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <p className="text-base md:text-lg font-comic">
          We are best friends who LOVE lemons. And when life gives you lemons... You Make Lemonade!
        </p>
      </motion.div>
      
      <motion.div 
        className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6"
        variants={container}
        initial="hidden"
        animate="show"
      >
        {besties.map((bestie, index) => (
          <motion.div 
            key={index}
            className={`card ${bestie.color} border-2 border-white`}
            variants={item}
            whileHover={{ 
              scale: 1.05, 
              rotate: [0, 1, -1, 1, 0],
              transition: { duration: 0.2 } 
            }}
          >
            <div className="flex items-center mb-2">
              <motion.div 
                className="text-4xl md:text-5xl mr-3 md:mr-4"
                animate={{ rotate: [0, 10, -10, 10, 0] }}
                transition={{ repeat: Infinity, duration: 2, repeatDelay: 1 }}
              >
                {bestie.emoji}
              </motion.div>
              <h2 className="text-xl md:text-2xl font-baloo font-bold">{bestie.name}</h2>
            </div>
            
            <p className="font-comic text-base md:text-lg">
              <span className="font-bold">Superpower:</span> {bestie.superpower}
            </p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default AboutPage; 